const whiteList = [ 
  '/login', //登录
  '/login1', //放心食安登录
];


export default whiteList;
